import { c as _c } from "react/compiler-runtime";
import { IndicatorBadge } from '@/components/Atoms/IndicatorBadge/IndicatorBadge';
import { ContactFormLink } from '@/components/Molecules/ContactUsFormLink/ContactFormLink';
import { useNavigationContext } from '@/contexts/NavigationContext/NavigationContext';
import useTranslation from '@/hooks/useTranslation';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import type { FCl } from 'react-fc';
import styled from 'styled-components';
export const AccountMenuList: FCl = t0 => {
  const $ = _c(49);
  const {
    className
  } = t0;
  const {
    notificationBadge
  } = useNavigationContext();
  const {
    t
  } = useTranslation("common");
  let itemsBadge = null;
  let whatsNewBadge = null;
  let myItemsurl = "/saved-items";
  if (notificationBadge?.myItemsCombinedCount) {
    let t1;
    if ($[0] !== notificationBadge.myItemsCombinedCount) {
      t1 = <PositionedIndicatorBadge>{notificationBadge.myItemsCombinedCount}</PositionedIndicatorBadge>;
      $[0] = notificationBadge.myItemsCombinedCount;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    itemsBadge = t1;
    if (notificationBadge.savedItemCount === 0) {
      myItemsurl = "/exports";
    }
  }
  if (notificationBadge?.whatsNewCount) {
    let t1;
    if ($[2] !== notificationBadge.whatsNewCount) {
      t1 = <PositionedIndicatorBadge>{notificationBadge.whatsNewCount}</PositionedIndicatorBadge>;
      $[2] = notificationBadge.whatsNewCount;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    whatsNewBadge = t1;
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Navigation, "Navigation: Account: My Items");
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = myItemsurl;
  let t3;
  if ($[5] !== t) {
    t3 = t("SiteSection.my_items");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== myItemsurl || $[8] !== t3) {
    t4 = <a data-analytics-tracking={t1} href={t2}>{t3}</a>;
    $[7] = myItemsurl;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== itemsBadge || $[11] !== t4) {
    t5 = <li>{t4}{itemsBadge}</li>;
    $[10] = itemsBadge;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Navigation, "Navigation: Account: What is New");
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("SiteSection.whats_new");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <a data-analytics-tracking={t6} href="/whats-new">{t7}</a>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8 || $[19] !== whatsNewBadge) {
    t9 = <li>{t8}{whatsNewBadge}</li>;
    $[18] = t8;
    $[19] = whatsNewBadge;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Navigation, "Navigation: Account: Account and Preferences");
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("SiteSection.account_and_preferences");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <li><a data-analytics-tracking={t10} href="/account">{t11}</a></li>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Navigation, "Navigation: Account: Help Center");
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("SiteSection.help");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14) {
    t15 = <li><a data-analytics-tracking={t13} href="/help">{t14}</a></li>;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Navigation, "Navigation: Account: ContactBNEF");
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t) {
    t17 = t("Navigation.contact");
    $[32] = t;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t17) {
    t18 = <li><ContactFormLink data-analytics-tracking={t16}>{t17}</ContactFormLink></li>;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.Navigation, "Navigation: Account: Logout");
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t) {
    t20 = t("Navigation.logout");
    $[37] = t;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t20) {
    t21 = <li><a data-analytics-tracking={t19} href="/logout">{t20}</a></li>;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== className || $[42] !== t12 || $[43] !== t15 || $[44] !== t18 || $[45] !== t21 || $[46] !== t5 || $[47] !== t9) {
    t22 = <List className={className}>{t5}{t9}{t12}{t15}{t18}{t21}</List>;
    $[41] = className;
    $[42] = t12;
    $[43] = t15;
    $[44] = t18;
    $[45] = t21;
    $[46] = t5;
    $[47] = t9;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  return t22;
};
const List = styled.ul`
    > li {
        position: relative;
        &:not(:last-child) {
            margin-bottom: var(--size-grid-half);
        }
        > a,
        > button {
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
    }
`;
const PositionedIndicatorBadge = styled(IndicatorBadge)`
    position: absolute;
    left: 100%;
    margin-left: 4px;
`;